<template>
  <ServiceLayout
    icon="notext-startrip.png"
    title="StarTrip"
    description="Cocok untuk anda yang ingin berpergian bebas antar kota atau negara tanpa keterikatan oleh batas waktu."
    :extra_hour="2"
    :tariffs="startrip_tariffs"
    :lists="startrip_list"
  />
</template>

<script>
import ServiceLayout from '@/components/ServiceLayout'

export default {
  name: 'StarTrip',
  components: {
    'ServiceLayout': ServiceLayout
  },
  data () {
    return {
      startrip_list: [
        /* {
          icon: 'users',
          icon_position: 'left',
          title: 'Kapasitas',
          subtitle: 'Cocok untuk anda yang memiliki keluarga, teman, atau sahabat dekat yang ingin bepergian dengan kapasitas 1 – 6 orang.'
        }, */
        {
          icon: 'waktu-fleksibel.png',
          icon_position: 'left',
          title: 'Flexibilitas',
          subtitle: 'Dengan layanan STARTRIP yang anda pilih, anda bebas bepergian ditemani oleh Guiders ke negara atau kota kemana pun yang anda mau.'
        },
        {
          icon: 'tarif-pasti.png',
          icon_position: 'right',
          title: 'Tarif Pasti',
          subtitle: 'Kami memberikan tarif pasti kepada setiap Member STARGUIDES dan tidak perlu khawatir tawar menawar lagi karna biaya nya sudah pasti.'
        },
        {
          icon: 'friendly.png',
          icon_position: 'left',
          title: 'Friendly',
          subtitle: 'Guiders kami akan selalu memberikan pelayanan dan sikap yang terbaik bagi semua member STARGUIDES.'
        },
        {
          icon: 'aman-nyaman.png',
          icon_position: 'right',
          title: 'Aman dan Nyaman',
          subtitle: 'Guiders kami akan selalu berusaha untuk memberikan keamanan dan kenyamanan selama bepergian di kota-kota yang anda kunjungi dengan STARTRIP.'
        },
        {
          icon: 'kemudahan-pembayaran.png',
          icon_position: 'left',
          title: 'Kemudahan Pembayaran',
          subtitle: 'Tidak perlu khawatir soal uang kembalian atau uang tunai, dengan, kartu kredit, layanan kami kini semakin praktis.'
        }
      ],
      startrip_tariffs: [
        'Rp. 2.241.792* per hari (Eropa, Turki, Korea, Tiongkok)'
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Service/StarTrip.vue